module.exports = __webpack_public_path__ + "img/20200922_changzhou_shengjiangtai.8574d8c9.jpg";